module.exports = __webpack_public_path__ + "site/img/function2.f173923.png";


//////////////////
// WEBPACK FOOTER
// ./site/function2.png
// module id = 98
// module chunks = 1